export function ensureOfficeInitializeWithLog(onInitialized?: () => void) {
    ;(window as any).Office = (window as any).Office || {}
    ;(window as any).Office.initialize = (reason: any) => {
        console.log("[Office] initialize fired. reason =", reason)
        try {
            onInitialized?.()
        } catch (e) {
            console.error("[Office] onInitialized error:", e)
        }
    }
}

export function loadOfficeJs(): Promise<void> {
    return new Promise((resolve, reject) => {
        if ((window as any).Office && (window as any).Office.onReady) {
            resolve()
            return
        }
        const s = document.createElement("script")
        s.src = "https://appsforoffice.microsoft.com/lib/1/hosted/office.js"
        s.async = true
        s.onload = () => resolve()
        s.onerror = () => reject(new Error("Failed to load office.js"))
        document.head.appendChild(s)
    })
}
